import { defineMessages } from 'react-intl-next';

export default defineMessages({
    vsaConnectorTitle: {
        defaultMessage: 'More help resources from {provider} are available',
        description: 'third party connection banner title',
        id: 'third-party-connectors.connectors.vsa-banner-connectors.vsa-connector-title',
    },
    vsaConnectorDescription: {
        defaultMessage: 'Connect your account for better responses',
        description: 'third party connection banner description',
        id: 'third-party-connectors.connectors.vsa-banner-connectors.vsa-connector-description',
    },
    connectButton: {
        defaultMessage: 'Connect to {provider}',
        description: 'third party connection banner connect button text',
        id: 'third-party-connectors.connectors.vsa-banner-connectors.connect-button',
    },
});
